const IAL_CATEGORY_SEARCH_PATHS = Object.freeze({
  legging: '/collections/leggings',
  leggings: '/collections/leggings',
  tights: '/collections/leggings',
  'yoga pants': '/collections/leggings',
  flare: '/collections/flare-collection',
  flares: '/collections/flare-collection',
  'flare leggings': '/collections/flare-collection',
  'flare pants': '/collections/flare-collection',
  jumpsuit: '/collections/jumpsuits-rompers',
  jumpsuits: '/collections/jumpsuits-rompers',
  romper: '/collections/jumpsuits-rompers',
  rompers: '/collections/jumpsuits-rompers',
  short: '/collections/shorts',
  shorts: '/collections/shorts',
  'biker shorts': '/collections/shorts',
  'bike shorts': '/collections/shorts',
  'şort': '/collections/shorts',
  skort: '/collections/skorts-skirts',
  skirt: '/collections/skorts-skirts',
  skirts: '/collections/skorts-skirts',
  etek: '/collections/skorts-skirts',
  set: '/collections/sets-hoodies',
  hoodie: '/collections/sets-hoodies',
  hoodies: '/collections/sets-hoodies',
});

window.IALCategorySearch = Object.freeze({
  normalize(term) {
    return term.normalize('NFKC').trim().toLocaleLowerCase().replace(/\s+/g, ' ');
  },

  getCollectionPath(term) {
    return IAL_CATEGORY_SEARCH_PATHS[this.normalize(term)] || null;
  },

  redirect(term, replace = false) {
    const path = this.getCollectionPath(term);
    if (!path) return false;

    if (replace) {
      window.location.replace(path);
    } else {
      window.location.assign(path);
    }
    return true;
  },

  redirectCurrentSearchPage() {
    if (!window.location.pathname.endsWith('/search')) return false;
    return this.redirect(new URLSearchParams(window.location.search).get('q') || '', true);
  },
});

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('submit', this.onCategorySearchSubmit.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onCategorySearchSubmit(event) {
    if (window.IALCategorySearch?.getCollectionPath(this.input.value)) {
      event.preventDefault();
      window.IALCategorySearch.redirect(this.input.value);
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
